import styled from 'styled-components';
import { FiChevronLeft } from 'react-icons/fi';

export const Container = styled.button`
  padding: 3px;
  border-radius: 100px;
  @media (min-width: 768px) {
    /* max-width: 65px; */
    max-height: 27px;
    padding: 3px;
    border-radius: 100px;
  }

  display: flex;
  align-items: center;
  justify-content: center;

  background: transparent;
  border: 1.5px solid ${(props) => props.theme.colors.border};
  transition: 0.4s;
  cursor: pointer;
  :focus {
    outline: 0;
  }
  :hover {
    background-color: ${({ theme }) => theme.colors.terciaryContent};
    border-color: ${({ theme }) => theme.colors.commentGrey};
  }
`;

export const Text = styled.p`
  color: ${(props) => props.theme.colors.darkerText};

  padding: 0 5px;
  font-size: 0.9em;
  @media (min-width: 768px) {
    font-weight: 400;
  }

  font-family: ${(props) => props.theme.fonts.primaryFont};
`;

export const Icon = styled(FiChevronLeft)`
  size: 15px;
  max-height: 15px;
  max-width: 15px;
  border-radius: 15px;

  @media (min-width: 768px) {
    size: 15px;
    max-height: 15px;
    max-width: 15px;
    border-radius: 15px;
    margin-right: 3px;
  }

  color: ${(props) => props.theme.colors.lighterText};

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${(props) => props.theme.colors.primary};
`;
